import { postAuth } from "utils/api";

export const resetPassword = async (params) => {
  return await postAuth("/reset-password", {
    ...params,
  });
};
